"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AutoComplete = _interopRequireDefault(require("../AutoComplete"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Tags = _interopRequireDefault(require("../Tags"));

var _constants = require("../Icon/constants");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SearchBar = function SearchBar(props) {
  var data = props.data,
      optionSource = props.options,
      placeholder = props.placeholder,
      disableFilters = props.disableFilters,
      classNameProp = props.className,
      dropdownClassName = props.dropdownClassName,
      filtersText = props.filtersText,
      onSearch = props.onSearch,
      onSelect = props.onSelect;

  var _useState = (0, _react.useState)(optionSource || data || []),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  (0, _react.useEffect)(function () {
    setOptions(optionSource);
  }, [optionSource]);
  (0, _react.useEffect)(function () {
    setOptions(data);
  }, [data]);

  var onSearchAutoComplete = function onSearchAutoComplete(val) {
    setOptions(data);
    setValue(val);
    onSearch(val);
  };

  var onSelectAutoComplete = function onSelectAutoComplete(val) {
    if (selected.includes(val)) {
      setValue('');
    } else {
      setValue('');
      setSelected(function (oldValue) {
        return [].concat(_toConsumableArray(oldValue), [val]);
      });
      onSelect([].concat(_toConsumableArray(selected), [val]));
    }
  };

  var handleTags = function handleTags(val) {
    setSelected(val);
    onSelect(val);
  };

  var className = (0, _utils.getClassNames)('SearchBar', classNameProp);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_AutoComplete.default, {
    dropdownClassName: (0, _utils.getClassNames)('search-dropdown', dropdownClassName),
    dataSource: options,
    value: value,
    placeholder: placeholder,
    filterOption: true,
    onSearch: onSearchAutoComplete,
    onSelect: onSelectAutoComplete
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    prefix: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: _constants.ICON_TYPE_SEARCH,
      className: "search-icon"
    })
  })), selected.length > 0 && !disableFilters && /*#__PURE__*/_react.default.createElement(_Tags.default, {
    data: selected,
    title: "".concat(filtersText, ":"),
    onChange: handleTags
  }));
};

SearchBar.propTypes = {
  /** Filter tags list */
  data: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Custom class to search */
  className: _propTypes.default.string,

  /** Placeholder text */
  placeholder: _propTypes.default.string,

  /** list of options to show in dropdown list */
  options: _propTypes.default.arrayOf(_propTypes.default.string),

  /** trigger on selected value from the search list function(value) */
  onSelect: _propTypes.default.func,

  /** triger on change function(value) */
  onSearch: _propTypes.default.func,

  /** whether the filters are hidden */
  disableFilters: _propTypes.default.bool,

  /** the dropdown custom class */
  dropdownClassName: _propTypes.default.string,

  /** the translation for filters */
  filtersText: _propTypes.default.string
};
SearchBar.defaultProps = {
  data: [],
  options: null,
  className: null,
  placeholder: 'Start typing...',
  onSelect: function onSelect() {},
  onSearch: function onSearch() {},
  disableFilters: false,
  dropdownClassName: undefined,
  filtersText: 'Filters'
};
var _default = SearchBar;
exports.default = _default;